import React, { Component } from 'react'
import { Button, Table, Modal, Spin,  message, Upload, Icon, Select,Form, Input  } from "antd"
import styled from "styled-components"
import dayjs from 'dayjs'
import UploadAPI from '@/API/upload'
import operatorAPI from '@/API/operator'
import testimeiAPI from '@/API/testimei'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const { Option } = Select;

const Div=styled.div`
  margin-bottom: 10px;
`

const SpanStyle = styled.span`
  margin:20px 20px;
`

const AddButton=styled(Button)`
  float:right;
  margin:20px 20px;
`
const DeleteButton=styled(Button)`
  float:right;
  margin:20px 20px 0 0;
`

const UploadTable=styled(Table)`
  margin:0 20px;
`

const MyUpload=styled(Upload)`
  .ant-upload-list-item{
    margin-top:24px;
    height:auto;
    background-color:#F8FAFB;
    padding:14px;
    cursor:pointer;
    color:#2FC29B;
    .ant-upload-list-item-name{
      text-decoration:underline;
    }
    .ant-upload-list-item-info{
      background-color:inherit !important;
    }
  }
  .ant-upload-list-item-info .anticon-paper-clip,
  .ant-upload-list-item .anticon-close{
    margin-top:14px;
    margin-right:14px;
  }
`

const TemplateLink = styled(Button)`
  margin-right:20px;
`;

class TestIMEI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey:'',
      IMEI:'',
      imeiList:[],
      operatorList:[],
      productList:[],
      operator:"",
      productName:"",
      uploadList:[],
      dialogShow:false,
      fileList:[],
      deleteDialogShow:false,
      deleteFileList:[],
      confirmLoading:false
    };
    
  }
  // 搜索内容框事件
  onChange=(e)=>{
    this.setState({searchKey:e.target.value})
  }
  // 搜索按钮事件
  getimeiList=()=>{
    this.setState({loading:true})
    testimeiAPI.searchTestIMEI({imei:this.state.searchKey}).then((res)=>{
      this.setState((state)=>{
        return {imeiList:[res]}
      })
      this.setState({loading:false})
    }).catch(()=>{
      this.setState({loading:false})
    }).finally(()=>{
      this.setState({IMEI:this.state.searchKey})
    })
  }
  initDialog=()=>{
    this.setState({dialogShow:true})
  }
  initDeleteDialog=()=>{
    this.setState({deleteDialogShow:true})
  }
  uploadInit=()=>{
    this.setState({
      operator:'',
      productName:'',
      productList:[],
      fileList:[]
    })
  }
  deleteUploadInit=()=>{
    this.setState({
      deleteFileList:[]
    })
  }
  handleCancel=()=>{
    this.setState({
      dialogShow:false,
      fileList:[]
    })
  }
  // 删除IMEI事件
  handleDeleteCancel=()=>{
    this.setState({
      deleteDialogShow:false,
      deleteFileList:[]
    })
  }
  // 手动上传IMEI
  handleOk=()=>{
    var {operator,productName,fileList}=this.state
    var {t,roleId}=this.props
    var formData;
    {
      formData=new FormData();
      formData.append('operator',operator)
      formData.append('productName',productName)
      formData.append('file',fileList[0])
      testimeiAPI.addTestIMEI(formData).then((res)=>{
        if(!res.code){
          message.success(t("Uploaded successfully."))
          this.uploadInit()
          this.setState({dialogShow:false})
        }else{
          message.error(res.info)
        }
      }).catch(()=>{
        message.error(t("Upload failed."))
      })
    }
  }
  // 手动删除IMEI
  handleDeleteOk=()=>{
    var {deleteFileList}=this.state
    const {t}=this.props
    if(!deleteFileList.length){
      return message.warning(this.props.t('Import IMEIs first.'))
    }
    var formData=new FormData();
    formData.append('file',deleteFileList[0])
    testimeiAPI.delTestIMEI(formData).then((res)=>{
      console.log(res)
      if(!res.code){
        message.success(t("Uploaded successfully."))
        this.deleteUploadInit()
        this.setState({deleteDialogShow:false})
      }else{
        message.error(res.info)
      }
    }).catch(()=>{
      message.error(t("Upload failed."))
    })
  }

  render() {
    const {IMEI,searchKey,imeiList,loading,dialogShow,fileList,operatorList,productList,deleteDialogShow,deleteFileList} = this.state
    const { t,roleId } = this.props
    const columns=[
      {
        title:this.props.t('IMEI'),
        dataIndex:'uuid',
        key:'uuid',
        render:(text)=>(text?IMEI:"该记录不存在")
      },
      {
        title:this.props.t('User Name'),
        dataIndex:'userName',
        key:'userName'
      },
      {
        title:this.props.t('Create Time'),
        dataIndex:'createTime',
        key:'userName',
        render:(text)=>(text?dayjs(text).format('YYYY-MM-DD HH:mm:ss'):"")
      }
    ]
    const props = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState({fileList:[file]})
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({fileList:[]})
      }
    }
    const deleteProps = {
      name: 'file',
      accept:'.xls,.xlsx,.csv',
      beforeUpload:(file)=>{
        this.setState({deleteFileList:[file]})
        return false
      },
      onPreview(file){
        var aLink=document.createElement('a')
        var blob=new Blob([file])
        aLink.download=file.name
        aLink.href=URL.createObjectURL(blob)
        aLink.click()
      },
      onRemove:()=>{
        this.setState({deleteFileList:[]})
      }
    }
    return (
      <div>
        <div>
          <Form layout="inline">
              <Form.Item label={t('IMEI')} style={{margin:20+"px",marginTop:16+"px",marginRight:0}}>
                <Input allowClear onChange={this.onChange}></Input>
              </Form.Item>
              <Form.Item>
                <Button style={{margin:20+"px",marginLeft:5+"px"}} onClick={this.getimeiList}>{t('Search')}</Button>
              </Form.Item>
              {
              roleId==1&&(
                <DeleteButton type="danger" onClick={this.initDeleteDialog}>{t('Delete')}</DeleteButton>
              )
              }
              
          <AddButton type="primary" onClick={this.initDialog}>{t('Upload IMEI')}</AddButton>
            </Form>
        </div>
        {
          imeiList && imeiList.length ? (
            <Spin spinning={loading}>
              <UploadTable dataSource={imeiList} columns={columns} rowKey="uuid"></UploadTable>
            </Spin>
          ):null
        }
        {
          // Upload IMEI
          dialogShow&&(
            <Modal title={t('Import IMEI')} visible={dialogShow} onOk={this.handleOk} onCancel={this.handleCancel} okText={t('OK')}>     
              <MyUpload {...props} fileList={fileList}>
                <div style={{marginBottom:'10px'}}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>
                  {t('Download Template(.xls)')}
                </TemplateLink>
                <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>
                  {t('Download Template(.csv)')}
                </TemplateLink>
                </div>
                
                <Button type="primary">
                  <Icon type="upload"></Icon>
                  {t('Import IMEI')}
                </Button>
              </MyUpload>
            </Modal>
          )
        }
        {
          // 删除IMEI
          deleteDialogShow&&(
            <Modal title={t('Import IMEI')} visible={deleteDialogShow} onOk={this.handleDeleteOk} onCancel={this.handleDeleteCancel} okText={t('OK')}>
              <MyUpload {...deleteProps} fileList={deleteFileList}>
                <div style={{marginBottom:'10px'}}>
                <TemplateLink href={'/api/downloadTpl?type=0'} onClick={(e)=>{e.stopPropagation()}}>
                  {t('Download Template(.xls)')}
                </TemplateLink>
                <TemplateLink href={'/api/downloadTpl?type=2'} onClick={(e)=>{e.stopPropagation()}}>
                  {t('Download Template(.csv)')}
                </TemplateLink>
                </div>
                
                <Button type="primary">
                  <Icon type="upload"></Icon>
                  {t('Import IMEI')}
                </Button>
              </MyUpload>
            </Modal>
          )
        }
      </div>
    );
  }
}

const mapStateToProps=(state)=>{
  return {
    menus:state.menus,
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(TestIMEI))
